<div
  class="mjml-renderer-header"
  [ngStyle]="headerStyle"
>
  <a [href]="logoTarget" target="_blank">
    <img [src]="logoSrc" [ngStyle]="logoStyle">
  </a>
</div>
